import { createAction } from '@reduxjs/toolkit';

import { eventSlice } from './eventSlice';

import type { AloneContext } from './telemetry/aloneRecoveryTracker';

export const {
  setActiveEventId,
  clearPinValue,
  addLastCallQuest,
  addAudience,
  addUserToAudience,
  demoteUserToAudience,
  removeUserFromAudience,
  setDisconnectedParticipants,
  clearStageInvitation,
  setCloudPlayer,
  setUserHandRaisedForUser,
  addRoom,
  removeRoom,
  addParticipantsWithRaisedHand,
  removeParticipantsWithRaisedHand,
  toggleShowAudienceList,
  setActivePanelTab,
  hideTranscriptionModal,
  updateRoom,
  setActiveSpeakersIds,
  setEventState,
  toggleRoomHelpCenter,
  setRematchCountdown,
  setNatteringResumeCountdown,
  setMatchingTeleprompterMounted,
} = eventSlice.actions;

/**
 * UI-derived telemetry signals (HNS-77). Pure signal actions — no reducer handles them; the
 * aloneTelemetry.listener observes them. Dispatched from NatteringCall's thin presence dispatcher.
 */
export const partnerPresenceChanged = createAction<{ present: boolean; context: AloneContext }>(
  'event/partnerPresenceChanged'
);
export const hostPresenceChanged = createAction<{ present: boolean }>('event/hostPresenceChanged');

/** The user explicitly left the nattering experience (distinct from rematch room-switch churn). */
export const natteringRoomLeft = createAction('event/natteringRoomLeft');
